// extracted by mini-css-extract-plugin
export default {"footerContainer":"PageFooter_footerContainer__-fYK9"};